var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNivel1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 85,
    viewBox: "0 0 61 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.316 30.158C60.316 46.8095 46.818 60.316 30.158 60.316C13.498 60.316 0 46.8095 0 30.158C0 13.5065 13.5065 0 30.158 0C46.8095 0 60.316 13.498 60.316 30.1495V30.158Z",
    fill: "url(#paint0_linear_1101_2967)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4903 44.1247C48.4903 54.2482 30.1558 84.2872 30.1558 84.2872C30.1558 84.2872 11.8213 54.2567 11.8213 44.1247C11.8213 33.9927 20.0323 25.7902 30.1558 25.7902C40.2793 25.7902 48.4903 34.0012 48.4903 44.1247Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4904 36.0603C48.4904 46.1838 30.1559 76.2228 30.1559 76.2228C30.1559 76.2228 11.8214 46.1923 11.8214 36.0603C11.8214 25.9283 20.0324 17.7258 30.1559 17.7258C40.2794 17.7258 48.4904 25.9368 48.4904 36.0603Z",
    fill: "url(#paint1_linear_1101_2967)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2167 30.1607C56.2167 44.5512 44.5462 56.2217 30.1557 56.2217C15.7652 56.2217 4.09473 44.5512 4.09473 30.1607C4.09473 15.7702 15.7652 4.09973 30.1557 4.09973C44.5462 4.09973 56.2167 15.7702 56.2167 30.1607Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2525 38.284C22.0829 38.284 21.0357 37.9984 20.1109 37.4272C19.1861 36.8424 18.4585 35.9992 17.9281 34.8976C17.3977 33.796 17.1325 32.4632 17.1325 30.8992C17.1325 29.3352 17.3977 28.0024 17.9281 26.9008C18.4585 25.7992 19.1861 24.9628 20.1109 24.3916C21.0357 23.8068 22.0829 23.5144 23.2525 23.5144C24.4357 23.5144 25.4829 23.8068 26.3941 24.3916C27.3189 24.9628 28.0465 25.7992 28.5769 26.9008C29.1073 28.0024 29.3725 29.3352 29.3725 30.8992C29.3725 32.4632 29.1073 33.796 28.5769 34.8976C28.0465 35.9992 27.3189 36.8424 26.3941 37.4272C25.4829 37.9984 24.4357 38.284 23.2525 38.284ZM23.2525 35.4892C23.8101 35.4892 24.2929 35.3328 24.7009 35.02C25.1225 34.7072 25.4489 34.2108 25.6801 33.5308C25.9249 32.8508 26.0473 31.9736 26.0473 30.8992C26.0473 29.8248 25.9249 28.9476 25.6801 28.2676C25.4489 27.5876 25.1225 27.0912 24.7009 26.7784C24.2929 26.4656 23.8101 26.3092 23.2525 26.3092C22.7085 26.3092 22.2257 26.4656 21.8041 26.7784C21.3961 27.0912 21.0697 27.5876 20.8249 28.2676C20.5937 28.9476 20.4781 29.8248 20.4781 30.8992C20.4781 31.9736 20.5937 32.8508 20.8249 33.5308C21.0697 34.2108 21.3961 34.7072 21.8041 35.02C22.2257 35.3328 22.7085 35.4892 23.2525 35.4892ZM33.1017 38.0392V24.9832L34.5297 26.4112H30.2457V23.7592H36.4065V38.0392H33.1017Z",
    fill: "#808080"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1101_2967",
    x1: 8.8315,
    y1: 51.4845,
    x2: 51.4845,
    y2: 8.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7A7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1101_2967",
    x1: 13.6319,
    y1: 59.6988,
    x2: 46.6799,
    y2: 26.6593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNivel1);
export default __webpack_public_path__ + "static/media/Nivel1.160dfebbac08528797a2795029e81c5a.svg";
export { ForwardRef as ReactComponent };